import { useContext, useCallback, useEffect } from 'react';
import { CAContext } from './src-contexts-CAContext.js';
import { getAvailableSchedule } from './src-utils-gcp-utils.js';
import { isMobile } from './src-utils-mobile-utils.js';
import { CaseDataContext } from './src-contexts-CaseDataContext.js';
import { useChatCaseDetails } from './src-hooks-utility-hooks-useChatCaseDetails.js';
import { useGCPChat } from './src-hooks-utility-hooks-useGCPChat.js';
import { useUserInfo } from './src-hooks-utility-hooks-useUserInfo.js';
import { API_ENDPOINTS } from './src-config-api-config.js';

const useUtilityHooks = () => {
  const {
    chatState: { locale, tenant },
    setChatState
  } = useContext(CAContext);
  const {
    state: { pageInfo },
    setState: setChatCaseContext
  } = useContext(CaseDataContext);
  const { data: userData, error: userError, loading: userInfoLoading, trigger: getUserInfo } = useUserInfo();
  const { data: gcpChatData, error: gcpChatError, loading: gcpChatLoading, trigger: getGCPChat } = useGCPChat(locale);
  const { data: chatCaseData, error: chatCaseError, loading: chatCaseLoading, trigger: getChatCaseData } = useChatCaseDetails();
  const playSoundMessageNotif = useCallback(() => {
    try {
      const audio = new Audio(API_ENDPOINTS.NOTIFICATION_SOUND);
      audio.play().catch((error) => {
        console.warn("Failed to play notification audio:", error);
      });
    } catch (error) {
      console.warn("Error creating audio element:", error);
    }
  }, []);
  useEffect(() => {
    if (!userData) getUserInfo();
  }, [getUserInfo, userData]);
  useEffect(() => {
    if (!gcpChatData) getGCPChat();
  }, [locale, getGCPChat, gcpChatData]);
  useEffect(() => {
    if (!chatCaseData)
      getChatCaseData({
        pageName: pageInfo?.pageName || "Studio",
        pageSection: pageInfo?.pageSection || "Studio",
        pageStage: pageInfo?.pageStage || "Design",
        isMobile: isMobile(),
        locale,
        tenant: tenant || "vistaprint",
        path: window.location.pathname,
        url: window.location.href
      });
  }, [getChatCaseData, chatCaseData]);
  useEffect(() => {
    if (chatCaseData) {
      setChatCaseContext((prev) => ({ ...prev, caseData: chatCaseData.caseData, queueType: chatCaseData.queueInfo }));
    }
  }, [chatCaseData]);
  useEffect(() => {
    if (userData) {
      setChatState((prevState) => ({
        ...prevState,
        userInfo: userData
      }));
    }
  }, [userData, setChatState]);
  useEffect(() => {
    if (gcpChatData) {
      const schedule = getAvailableSchedule(gcpChatData?.formattedBusinessHours, gcpChatData?.timezone?.name);
      setChatState((prevState) => ({
        ...prevState,
        gcpChatData,
        availableSchedule: schedule
      }));
    }
  }, [gcpChatData, setChatState]);
  useEffect(() => {
    if (playSoundMessageNotif)
      setChatState((prev) => ({
        ...prev,
        playSoundMessageNotif
      }));
  }, [playSoundMessageNotif]);
  return {
    utilityHooksData: {
      userData,
      gcpChatData,
      chatCaseData
    },
    utilityHooksLoading: {
      userInfoLoading,
      gcpChatLoading,
      chatCaseLoading
    },
    utilityHooksError: {
      userError,
      gcpChatError,
      chatCaseError
    },
    utilityHooksTriggers: {
      getUserInfo,
      getGCPChat,
      getChatCaseData
    },
    playSoundMessageNotif
  };
};

export { useUtilityHooks };
//# sourceMappingURL=src-hooks-useUtilityHooks.js.map
